// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7SaFl","controls":"styles_controls___Ozye","charLimit":"styles_charLimit__2xtwq","input":"styles_input__1BLme","send":"styles_send__2HmWK"};